<template>
  <div class="ua-flag-team-player">
    <div class="hero">
      <div class="team-row">
        <div class="team-logo">
          <img :src="filterImage(team.badge, 40, 40, 2)" alt="" />
        </div>
        <div class="team-meta">
          <div class="team-name overflow-text">{{ team.name }}</div>
          <div class="officer" v-if="leader">领队：{{ leader }}</div>
          <div class="officer" v-if="coach">教练：{{ coach }}</div>
        </div>
      </div>
    </div>
    <div class="sheet">
      <div class="sheet-title">
        <span class="sheet-title-text">球员名单</span>
      </div>
      <div class="player-list">
        <div class="player-card" v-for="item in players" :key="item.id">
          <div class="avatar" v-if="item.photo">
            <img :src="imgView(item.photo)" alt="" />
          </div>
          <div class="player-info">
            <div class="true-name overflow-text">{{ item.trueName }}</div>
            <div class="jersey" v-if="showJersey(item)">{{ formatJersey(item.number) }}</div>
            <div class="position overflow-text" v-if="item.position">{{ item.position }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getBMPlayerList } from '@/api/match'
import { QNImageUtil } from '@/utils'
import { Toast } from 'vant'
import Vue from 'vue'

Vue.use(Toast)

export default {
  data() {
    return {
      matchId: '',
      teamId: '',
      team: {},
      players: [],
      leader: '',
      coach: ''
    }
  },
  created() {
    this.matchId = this.$route.query.matchId
    this.teamId = this.$route.query.teamId
    if (!this.matchId || !this.teamId) {
      Toast('缺少赛事或球队参数')
      return
    }
    this.getBMPlayerList()
  },
  methods: {
    getBMPlayerList() {
      getBMPlayerList({ teamId: this.teamId, matchId: this.matchId }).then(res => {
        const data = res.data
        this.players = data.players || []
        this.team = data.team || {}
        const officers = data.offices || []
        const ls = []
        const cs = []
        officers.forEach(o => {
          if (o.role === '领队') {
            ls.push(o.trueName)
          } else if (o.role === '教练') {
            cs.push(o.trueName)
          }
        })
        this.leader = ls.join('、')
        this.coach = cs.join('、')
      })
    },
    showJersey(item) {
      return item.number !== undefined && item.number !== null && item.number >= 0
    },
    formatJersey(num) {
      if (num === 0) return '0号'
      if (num > 0 && num <= 9) return `${String(num).padStart(2, '0')}号`
      return `${num}号`
    },
    filterImage(img, w, h, mode) {
      if (!img) return ''
      return QNImageUtil.imageView(img, parseInt(2 * w, 10), parseInt(2 * h, 10), mode)
    },
    imgView(img) {
      return QNImageUtil.imageView(img, 120, 120, 2)
    }
  }
}
</script>

<style scoped lang="scss">
.overflow-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ua-flag-team-player {
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  background: linear-gradient(180deg, #DC0019 2%, #282831 100%);
  overflow-y: auto;
}

.hero {
  padding: 20px 18px 28px;
  color: #fff;
  flex-shrink: 0;
}

.team-row {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}

.team-logo {
  width: 70px;
  height: 70px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.team-meta {
  flex: 1;
  min-width: 0;
  padding-top: 2px;
}

.team-name {
  font-size: 20px;
  font-weight: 600;
  line-height: 1.3;
  margin-bottom: 10px;
}

.officer {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.92);
  line-height: 1.5;
  margin-top: 4px;
}

.sheet {
  flex: 1;
  background: #000;
  border-radius: 22px 22px 0 0;
  position: relative;
  z-index: 0;
  padding: 22px 16px 32px;
  box-sizing: border-box;
  margin-top: 0;
}

.sheet-title {
  margin-bottom: 18px;
}

.sheet-title-text {
  font-size: 20px;
  font-weight: bold;
  color: #fff;
}

.player-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.player-card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 14px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.1);
  box-sizing: border-box;
}

.avatar {
  width: 55px;
  height: 55px;
  flex-shrink: 0;
  border-radius: 50%;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.08);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.player-info {
  flex: 1;
  min-width: 0;
}

.true-name {
  font-size: 16px;
  font-weight: 500;
  color: #fff;
}

.jersey {
  font-size: 13px;
  color: #fff;
  margin-top: 8px;
}

.position {
  font-size: 13px;
  color: #B4B4BF;
  margin-top: 6px;
}
</style>
